import React from 'react';
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';
import {
    SlideContainer, SlideTitle, SlideSubtitle, SlideText, BulletList, BulletItem, HighlightBox, IconCircle,
    welcomeSlide, historicSlide, finalSlide,
} from 'components/v3/onboarding/OnboardingSlideElements';

// ==========================================
// Profil WAREHOUSE — warehouse-manager
// Atterrissage : /my-warehouse. Voit Mon entrepôt + Historique + Paramètres.
// ==========================================

export const warehouseSlides = () => [
    welcomeSlide(
        "Votre espace s'articule autour de « Mon entrepôt », l'espace dédié à la gestion de votre entrepôt, et de « Historique », qui garde la trace de tous les scans.",
    ),

    {
        title: '1 · Mon entrepôt',
        content: (
            <SlideContainer>
                <SlideTitle>
                    <IconCircle><WarehouseOutlinedIcon /></IconCircle>
                    1 · Mon entrepôt
                </SlideTitle>

                <SlideSubtitle>Votre journée</SlideSubtitle>
                <BulletList>
                    <BulletItem>
                        <strong>Expéditions aujourd'hui</strong> — ce qui est parti depuis ce matin, avec la comparaison
                        à hier et votre avancement sur la cible du jour.
                    </BulletItem>
                    <BulletItem>
                        <strong>Pipeline de retour</strong> — le trajet des emballages qui reviennent, en trois
                        étapes : <strong>En livraison vers votre entrepôt</strong> (encore chez le transporteur) → <strong>Sur le quai</strong>{' '}
                        (réceptionné, en attente de tri — cette étape n'est pas disponible sans connexion avec votre transporteur) → <strong>Prêt à emballer</strong> (emballages en stock).
                    </BulletItem>
                </BulletList>

                <SlideSubtitle>Votre stock et sa qualité</SlideSubtitle>
                <BulletList>
                    <BulletItem>
                        <strong>Disponibilité par gamme et taille</strong> — le tableau qui vous dit si vous pouvez tenir
                        les commandes, ligne par gamme et colonne par taille.
                    </BulletItem>
                    <BulletItem>
                        <strong>Anomalies</strong> — les emballages déclarés abîmés, comptés par catégorie.
                    </BulletItem>
                    <BulletItem>
                        <strong>Charge prévisionnelle</strong> — les prochaines commandes et expéditions prévues vers vos points de retraits. Cette carte  ne peut être disponible qu'avec la connexion aux
                        transporteurs.
                    </BulletItem>
                </BulletList>

                <HighlightBox>
                    <SlideText sx={{ marginBottom: 0 }}>
                        ✏️ La cible d'expéditions du jour se règle avec le petit crayon, sur la carte
                        « Expéditions aujourd'hui ».
                    </SlideText>
                </HighlightBox>
            </SlideContainer>
        ),
    },

    historicSlide(2, false),
    finalSlide(),
];
